import { Icon, IconName } from "@zapier/zinnia-icons";
import { SkeletonBlock, SkeletonText } from "@zapier/design-system";
import styles from "./LoadingCard.module.css";

interface LoadingCardProps {
  kind: "table" | "zap" | "interface" | "chatbot" | "canvas";
}

const LoadingCard = ({ kind }: LoadingCardProps) => {
  let icon: IconName = "miscBoltAltFill";

  switch (kind) {
    case "chatbot": {
      icon = "navAIChatbot";

      break;
    }
    case "interface": {
      icon = "navInterfaces";

      break;
    }
    case "table": {
      icon = "navTables";

      break;
    }
    case "canvas": {
      icon = "navCanvas";

      break;
    }
    // No default
  }

  return (
    <li className={styles.card}>
      <Icon name={icon} color="BrandOrange" size={30} />
      <SkeletonText lines={1} />
      <SkeletonBlock />
    </li>
  );
};

export default LoadingCard;
